module.exports = __webpack_public_path__ + "img/4.85059d6a.jpg";